<!--  -->
<template>
  <div class="contactUs">
    <h1>联系我们</h1>
    <p>公司名称：北京爱启航网络科技有限公司</p>
    <p>地址： 北京市海淀区北三环西路99号院西海国际大厦3号楼1217</p>
    <p>电话： 400-856-9099</p>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.contactUs {
  padding: 36px;
  h1 {
    padding: 0 0 40px 0;
    font-weight: 800;
    font-size: 32px;
    text-align: center;
  }
  p {
    color: #333;
    font-size: 28px;
    line-height: 40px;
  }
}
</style>
